import {DataService} from 'core/data-services/data-service';
import {Injectable} from '@angular/core';
import {URLHelper} from 'helpers/url.helper';
import {HttpHeaders} from '@angular/common/http';

@Injectable()
export class OneMoveDataService extends DataService {

  getParking1MoveMembers(options: any, searchFilter: string, searchCategory?: any): Promise<any> {
    options = options || {};
    options.query = options.query || {};
    options.query['query'] = URLHelper.buildGeneralSearchFilter(
      {'name': 'string', 'email': 'string', 'phoneNumber': 'string'},
      searchFilter || '*');
    if (searchFilter) {
      options.query['licensePlate'] = searchFilter
      options.query['addressNumber'] = searchFilter
    }
    let url = URLHelper.buildQueryString('/1move/members?', options.query, '');
    if (searchCategory) url = url + `;(status==${searchCategory})`;
    return this.get("", {"parking-lots": "PARKING_LOT_ID"}, url + '&sort=createdDate,desc');
  }

  getParking1MoveMemberById(memberId): Promise<any> {
    let url = URLHelper.buildQueryString('/1move/members/' + memberId, '', '');
    return this.get("", {"parking-lots": "PARKING_LOT_ID"}, url);
  }

  createParking1MoveMember(memberBody: any): Promise<any> {
    let options = { headers: new HttpHeaders().set('Content-Type', 'application/json') };
    return this.post("", {"parking-lots": "PARKING_LOT_ID"}, "/1move/members", memberBody, options);
  }

  updateParking1MoveMember(membersId: number, memberBody: any): Promise<any> {
    let options = { headers: new HttpHeaders().set('Content-Type', 'application/json') };
    return this.put("", {"parking-lots": "PARKING_LOT_ID", "1move/members": membersId}, '', memberBody, options);
  }

  deleteParking1MoveMembers(membersId: Array<any>): Promise<any> {
    let membersIdsFormat = membersId.map((data) => {
      return data.id;
    }).join(",");
    return this.delete("", {"parking-lots": "PARKING_LOT_ID"}, "/1move/members?ids=" + membersIdsFormat);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/data-services/1move/1move.service.ts